import React, { useEffect, useState, useContext } from 'react';

import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import classNames from 'classnames';

import Switch from '../../../../../../Switch';
import Badge from './Badge';

import { UiContext } from '../../../../../../../context/UiContext';
import classes from './styles.module.scss';
import AdminService from '../../../../../../../services/AdminService';

export default function Badges({ company, refetch }) {
  const [areBadgesEnabled, setAreBadgesEnabled] = useState(false);
  const [enabledBadges, setEnabledBadges] = useState([]);

  const { setIsFetching } = useContext(UiContext);

  const { t } = useTranslation();

  const { data: tags } = useQuery({
    queryKey: ['tags'],
    queryFn: () =>
      AdminService.getCompanyTags({
        pageSize: 50,
      }),
  });

  useEffect(() => {
    if (company?.company?.companyTags?.length) {
      setEnabledBadges(company?.company?.companyTags ?? []);
      setAreBadgesEnabled(true);
    } else {
      setAreBadgesEnabled(false);
      setEnabledBadges([]);
    }
  }, [company]);

  const addTagToCompany = async (jobTags) => {
    try {
      setIsFetching(true);
      await AdminService.addTagToCompany({
        id: company?.id,
        companyTagIds: areBadgesEnabled ? jobTags?.map((tag) => tag.id) : [],
      });
      if (refetch) {
        await refetch();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsFetching(false);
    }
  };

  return (
    <div className={classes.badgesContainer}>
      <Switch
        label={t(
          'dashboardComponents.Companies.CompanyDetails.Settings.Badges.enableBadges'
        )}
        isEnabled={areBadgesEnabled}
        onClick={() => {
          if (areBadgesEnabled) {
            setAreBadgesEnabled(false);
            addTagToCompany();

            return;
          }
          setAreBadgesEnabled((prevState) => !prevState);
        }}
      />
      <div
        className={classNames(classes.badges, {
          [classes.active]: areBadgesEnabled,
        })}
      >
        {tags?.data?.map?.((tag) => (
          <Badge
            key={tag.id}
            badge={tag}
            areBadgesEnabled={areBadgesEnabled}
            enabledBadges={enabledBadges}
            addTagToCompany={addTagToCompany}
          />
        ))}
      </div>
    </div>
  );
}
